import React, { useEffect, useRef, useState } from "react";
import ReactSelect, { components } from "react-select";

const SwitchToggle = ({ filters, getFieldCompletedValue }) => {
  const { completed } = filters;
  let [text, setText] = useState();
  const [showDropdown, setShowDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    let text = "";
    if (completed === "false") {
      text = "pending";
    } else if (completed === "true") {
      text = "done";
    } else {
      text = "all";
    }

    setText(text);
  }, [completed]);

  const statusChangeHandler = (value) => {
    getFieldCompletedValue(value);
    let text = "";
    if (value === "false") {
      text = "pending";
    } else if (value === "true") {
      text = "done";
    } else {
      text = "all";
    }
    setText(text);
    setShowDropDown(false);
  };

  const showDropDownHandler = () => {
    setShowDropDown(true);
  };

  useEffect(() => {
    window.addEventListener("mousedown", (e) => {
      if (dropdownRef.current && !dropdownRef.current?.contains(e.target)) {
        setShowDropDown(false);
      }
    });

    return () => {
      window.removeEventListener("mousedown", (e) => {});
    };
  }, []);

  // const customStyles = {
  //   control: (styles, state) => {
  //     return {
  //       ...styles,
  //       fontSize: "12px",
  //       textAlign: "left",
  //       boxShadow: "none",
  //       overflowY: "auto",
  //       // width: 230,
  //     }
  // option: (provided, state) => ({
  //   ...provided,
  //   display: "flex",
  //   alignItems: "center",
  //   paddingLeft: 5,
  // }),
  // };

  const customStyles = {
    control: (styles, state) => {
      return {
        ...styles,
        textAlign: "left",
        boxShadow: "none",
        overflowY: "auto",

        // width: 230,
      };
    },
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      zIndex: 999999999,
    }),
  };

  const SingleValueWithIcon = ({ children, ...props }) => {
    console.log(props, 24234324324);
    return (
      <components.SingleValue {...props}>
        {props.data.value === "false" ? (
          <span>
            <i
              class="fa fa-clock"
              aria-hidden="true"
              style={{ fontWeight: "bold", color: "orange" }}
            ></i>{" "}
            &nbsp;
            {props.data.label}
          </span>
        ) : props.data.value === "true" ? (
          <span>
            <i
              class="fa fa-check-circle"
              aria-hidden="true"
              style={{ fontWeight: "bold", color: "green" }}
            ></i>{" "}
            &nbsp;
            {props.data.label}
          </span>
        ) : (
          <span style={{ display: "flex", alignItems: "center" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13px"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M448 256c0-106-86-192-192-192v384c106 0 192-86 192-192M0 256a256 256 0 1 1 512 0a256 256 0 1 1-512 0"
              />
            </svg>{" "}
            &nbsp; All
          </span>
        )}
      </components.SingleValue>
    );
  };

  const OptionWithIcon = ({ children, ...props }) => {
    console.log(props, 2342432432432);
    return (
      <components.Option {...props}>
        {props.label === "Pending" ? (
          <span>
            <i
              class="fa fa-clock"
              aria-hidden="true"
              style={{ fontWeight: "normal" }}
            ></i>{" "}
            {props.label}
          </span>
        ) : props.label === "Done" ? (
          <span>
            <i
              class="fa fa-check-circle"
              aria-hidden="true"
              style={{ fontWeight: "normal" }}
            ></i>{" "}
            {props.label}
          </span>
        ) : (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13px"
              height="1em"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M448 256c0-106-86-192-192-192v384c106 0 192-86 192-192M0 256a256 256 0 1 1 512 0a256 256 0 1 1-512 0"
              />
            </svg>{" "}
            All
          </span>
        )}
      </components.Option>
    );
  };

  const options = [
    { value: "all", label: "All" },
    { value: "true", label: "Done" },
    { value: "false", label: "Pending" },
  ];

  return (
    <div className="parent_status">
      <ReactSelect
        options={options}
        classNamePrefix={"switch_toggle"}
        value={options.filter((item) => item.value === completed)}
        components={{
          Option: OptionWithIcon,
          SingleValue: SingleValueWithIcon,
        }}
        styles={customStyles}
        onChange={(evt) => statusChangeHandler(evt.value)}
      />
      {/* <div
        className="main_status_button"
        style={
          completed === "true"
            ? {
                backgroundColor: "rgba(23, 162, 184, 0.1)",
                color: "rgb(23, 162, 184)",
                border: "1px solid rgba(23, 162, 184, 0.5)",
              }
            : completed === "false"
            ? {
                backgroundColor: "rgba(255, 193, 7, 0.1)",
                color: "rgb(255, 193, 7)",
                border: "1px solid rgba(255, 193, 7, 0.5)",
              }
            : {
                backgroundColor: "rgba(0, 123, 255, 0.1)",
                color: "rgb(0, 123, 255)",
                border: "1px solid rgba(0, 123, 255, 0.5)",
              }
        }
        onClick={showDropDownHandler}
      >
        <span className="status">
          {text?.charAt(0).toUpperCase() + text?.slice(1)}
        </span>
        <span className="icon">
          <i className="fa fa-chevron-down font-small"></i>
        </span>
      </div>
      {showDropdown && (
        <div className="status_options" ref={dropdownRef}>
          <ul>
            <li
              onClick={statusChangeHandler.bind(this, "false")}
              style={
                completed === "false" ? { backgroundColor: "#f4f7fc" } : {}
              }
            >
              Pending
            </li>
            <li
              onClick={statusChangeHandler.bind(this, "true")}
              style={completed === "true" ? { backgroundColor: "#f4f7fc" } : {}}
            >
              Done
            </li>
            <li
              onClick={statusChangeHandler.bind(this, "all")}
              style={completed === "all" ? { backgroundColor: "#f4f7fc" } : {}}
            >
              All
            </li>
          </ul>
        </div>
      )} */}
    </div>
  );
};

export default SwitchToggle;
